document.addEventListener("DOMContentLoaded", () => {
  const carousel = document.querySelector(".hero-media-carousel");
  let carouselHeight = carousel.offsetHeight;
  const navSpacing = document.querySelector(".nav-spacing");
  if (navSpacing) {
    carouselHeight -= navSpacing.offsetHeight;
  }
  carousel.style.height = `${carouselHeight}px`;

  const slides = carousel.querySelectorAll(".hero-media-carousel__slide");
  const dots = carousel.querySelectorAll(".hero-media-carousel__dot");

  if (slides.length < 2) {
    if (slides[0].querySelector("video")) {
      dots[0].parentElement.style.display = "none";
    } else {
      carousel.querySelector(".hero-media-carousel__navigation").style.display =
        "none";
      return;
    }
  }

  const progressFill = carousel.querySelector(
    ".hero-media-carousel__progress-fill"
  );
  const soundToggle = carousel.querySelector(
    ".hero-media-carousel__sound-toggle"
  );

  const animationDuration = 500;
  const baseAutoRotateInterval = 4000;
  let autoRotateInterval = baseAutoRotateInterval;
  let currentSlide = 0;
  let isAnimating = false;
  let autoRotateTimer;
  let autoRotateIntervalId;
  let slideShiftTimer;
  let isHoveringButton = false;
  let currentVideo = null;
  let isDragging = false;
  let dragStartX = undefined;
  let dragCurrentX = 0;
  let dragStartTime = 0;
  let activeLink = null;
  let dragOffset = 0;

  // Initialize Intersection Observer for video muting
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        const slide = video.closest(".hero-media-carousel__slide");
        const isActiveSlide = slide.classList.contains(
          "hero-media-carousel__slide--active"
        );

        if (!entry.isIntersecting) {
          // Video is out of view - mute it
          video.muted = true;
        } else if (isActiveSlide) {
          // Video is in view and is the active slide
          // Restore its previous mute state (handled by sound toggle)
          if (soundToggle.classList.contains("on")) {
            video.muted = false;
          } else {
            video.muted = true;
          }
          // Update sound toggle visibility
          soundToggle.classList.add(
            "hero-media-carousel__sound-toggle--visible"
          );
        }
      });
    },
    {
      threshold: 0.1, // When at least 10% of video is visible
    }
  );

  // Initialize
  function initCarousel() {
    // Show first slide
    slides[currentSlide].classList.add("hero-media-carousel__slide--active");
    dots[currentSlide].classList.add("hero-media-carousel__dot--active");

    const firstVideo = slides[currentSlide].querySelector("video");
    if (firstVideo) {
      currentVideo = firstVideo;
      soundToggle.classList.add(
        "hero-media-carousel__sound-toggle--visible",
        "off"
      );
      observer.observe(firstVideo);

      // 1. Replace setInterval with event-based ready check
      const handleVideoReady = () => {
        firstVideo
          .play()
          .then(() => {
            firstVideo.currentTime = 0;
            autoRotateInterval = Math.max(
              baseAutoRotateInterval,
              firstVideo.duration * 1000
            );
            startAutoRotation();
            resetProgressBar();
          })
          .catch((e) => {
            console.error("Video play failed:", e);
            // Fallback to image behavior if video fails
            resetProgressBar();
            startAutoRotation();
          });
      };

      // 2. Check if already loaded
      if (firstVideo.readyState >= 2) {
        // HAVE_CURRENT_DATA
        handleVideoReady();
      } else {
        // 3. Listen for metadata load (runs once)
        firstVideo.addEventListener("loadedmetadata", handleVideoReady, {
          once: true,
        });

        // 4. Timeout fallback (safety net)
        const timeoutId = setTimeout(() => {
          firstVideo.removeEventListener("loadedmetadata", handleVideoReady);
          console.warn("Video loading timeout");
          handleVideoReady(); // Attempt anyway
        }, 3000); // 3-second timeout

        // 5. Cleanup on unmount (for SPA/Shopify compatibility)
        window.addEventListener("unload", () => {
          clearTimeout(timeoutId);
          firstVideo.removeEventListener("loadedmetadata", handleVideoReady);
        });
      }
    } else {
      resetProgressBar();
      startAutoRotation();
    }
  }

  // Show slide with fade transition
  function showSlide(index) {
    // Wrap around if at ends
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;

    // Pause current video if exists
    if (currentVideo) {
      currentVideo.pause();
      currentVideo.muted = true; // Mute when leaving
      currentVideo = null;
    }

    // Handle video slides
    const newSlide = slides[index];
    const video = newSlide.querySelector("video");
    if (video) {
      currentVideo = video;
      observer.observe(video);

      soundToggle.classList.add("hero-media-carousel__sound-toggle--visible");
      soundToggle.classList.toggle("on", !video.muted);
      soundToggle.classList.toggle("off", video.muted);

      video.currentTime = 0;
      video.play().catch((e) => console.log("Video play failed:", e));

      autoRotateInterval = Math.max(
        baseAutoRotateInterval,
        video.duration * 1000
      );
    } else {
      soundToggle.classList.remove(
        "hero-media-carousel__sound-toggle--visible"
      );
      autoRotateInterval = baseAutoRotateInterval;
    }
    if (isAnimating || index === currentSlide) return;
    clearTimeout(slideShiftTimer);
    isAnimating = true;

    // Update navigation dots
    dots.forEach((dot, i) => {
      dot.classList.toggle("hero-media-carousel__dot--active", i === index);
    });

    // Fade out current slide
    slides[currentSlide].classList.remove("hero-media-carousel__slide--active");

    // Fade in new slide
    slides[index].classList.add("hero-media-carousel__slide--active");

    slideShiftTimer = setTimeout(() => {
      currentSlide = index;
      isAnimating = false;
      resetAutoRotation();
    }, animationDuration);
  }

  // [Rest of your existing perfect code remains exactly the same...]
  function resetProgressBar() {
    progressFill.style.transition = "none";
    progressFill.style.width = "0";

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        progressFill.style.transition = `width ${autoRotateInterval}ms linear`;
        progressFill.style.width = "100%";
      });
    });
  }

  function startAutoRotation() {
    clearTimeout(autoRotateTimer);
    if (slides.length < 2) {
      if (currentVideo) {
        showSlide(currentSlide);
        resetProgressBar();
        autoRotateTimer = setTimeout(() => {
          showSlide(currentSlide);
          resetProgressBar();
        }, autoRotateInterval);
      }
      return;
    }
    clearInterval(autoRotateIntervalId);
    autoRotateTimer = setTimeout(() => {
      if (!isHoveringButton && !isDragging) {
        showSlide(currentSlide + 1);
        resetProgressBar();
      } else {
        autoRotateIntervalId = setInterval(() => {
          if (!isHoveringButton && !isDragging) {
            showSlide(currentSlide + 1);
            resetProgressBar();
            clearInterval(autoRotateIntervalId);
          }
        }, 500);
      }
    }, autoRotateInterval);
  }

  function resetAutoRotation() {
    clearTimeout(autoRotateTimer);
    startAutoRotation();
  }

  // Enhanced sound toggle functionality
  soundToggle.addEventListener("click", () => {
    if (currentVideo) {
      currentVideo.muted = !currentVideo.muted;
      soundToggle.classList.toggle("on", !currentVideo.muted);
      soundToggle.classList.toggle("off", currentVideo.muted);

      // Update all videos in carousel to maintain consistent state
      document
        .querySelectorAll(".hero-media-carousel__media")
        .forEach((video) => {
          if (video !== currentVideo) {
            video.muted = currentVideo.muted;
          }
        });
    }
  });

  // [Rest of your existing event listeners remain unchanged...]
  dots.forEach((dot, index) => {
    dot.addEventListener("click", () => {
      if (!isAnimating && index !== currentSlide) {
        showSlide(index);
        resetProgressBar();
      }
    });
  });

  slides.forEach((slide) => {
    const buttons = slide.querySelectorAll(".hero-media-carousel__button");
    buttons.forEach((button) => {
      button.addEventListener("mouseenter", () => {
        isHoveringButton = true;
      });
      button.addEventListener("mouseleave", () => {
        isHoveringButton = false;
      });
    });
  });

  if (slides.length > 1) {
    // 1. Configuration (easy to adjust)
    const DRAG_CONFIG = {
      startThreshold: 5, // Minimum movement to start drag (px)
      triggerThreshold: 50, // Distance to trigger slide change (px)
      clickMaxTime: 200, // Max time to consider as click (ms)
    };

    // 2. Unified Pointer Event Handlers
    function handleDragStart(e) {
      // Handle both mouse and touch
      const clientX = e.clientX || e.touches[0].clientX;

      if (e.target.closest("a")) {
        activeLink = e.target.closest("a");
        e.preventDefault();
      }

      isDragging = false;
      dragStartX = clientX;
      dragCurrentX = clientX;
      dragStartTime = Date.now();
    }

    function handleDragMove(e) {
      if (dragStartX === undefined) return;

      const clientX = e.clientX || e.touches[0].clientX;
      dragCurrentX = clientX;
      dragOffset = dragCurrentX - dragStartX;

      if (Math.abs(dragOffset) > DRAG_CONFIG.startThreshold) {
        isDragging = true;
        if (activeLink) activeLink.style.pointerEvents = "none";
      }
    }

    function handleDragEnd() {
      // Handle click vs drag
      if (activeLink && !isDragging) {
        const clickTime = Date.now() - dragStartTime;
        if (clickTime < DRAG_CONFIG.clickMaxTime) {
          window.location.href = activeLink.href;
        }
      }

      // Handle slide change
      if (isDragging) {
        if (dragOffset < -DRAG_CONFIG.triggerThreshold) {
          showSlide(currentSlide + 1);
        } else if (dragOffset > DRAG_CONFIG.triggerThreshold) {
          showSlide(currentSlide - 1);
        }
        resetProgressBar();
      }

      // Reset state
      isDragging = false;
      dragStartX = undefined;
      if (activeLink) {
        activeLink.style.pointerEvents = "auto";
        activeLink = null;
      }
    }

    // 3. Register Events (with cleanup)
    function initDragHandlers() {
      carousel.addEventListener("pointerdown", handleDragStart);
      carousel.addEventListener("pointermove", handleDragMove);
      document.addEventListener("pointerup", handleDragEnd);

      // Fallback for older browsers
      if (!window.PointerEvent) {
        carousel.addEventListener("mousedown", handleDragStart);
        carousel.addEventListener("touchstart", handleDragStart, {
          passive: true,
        });
        // ... (similar fallbacks for move/end)
      }
    }

    function cleanupDragHandlers() {
      carousel.removeEventListener("pointerdown", handleDragStart);
      carousel.removeEventListener("pointermove", handleDragMove);
      document.removeEventListener("pointerup", handleDragEnd);
    }

    // 4. Initialize/cleanup when needed
    initDragHandlers();

    // For Shopify/SPA compatibility:
    window.addEventListener("unload", cleanupDragHandlers);
  }
  // Initialize the carousel
  initCarousel();
});
